if (!customElements.get("product-tabs")) {
  customElements.define(
    "product-tabs",
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.querySelectorAll(".product-tabs--header a").forEach((tab) => {
          tab.addEventListener("click", this.handleTabClick.bind(this));
        });
      }

      handleTabClick(event) {
        event.preventDefault();
        this.querySelector(".product-tabs--header .active").classList.remove(
          "active",
        );
        event.target.classList.add("active");

        this.querySelector(`.tab-content:not(.hidden)`).classList.add("hidden");
        this.querySelector(`#${event.target.dataset.target}`).classList.remove(
          "hidden",
        );
      }
    },
  );
}
